<div class="grid lg:grid-cols-3 grid-cols items-center lg:gap-4 gap-8 w-full">
  <div [class]="'sell-package-wrapper ' + item.cssClassName" class="min-h-[293px] h-auto md:h-full" *ngFor="let item of this.products">
    <input [checked]="item.isSelected" type="radio" [id]="'package-' + item!.cssClassName" name="package" [value]="item"
      (change)="selectProduct(item)" formControlName="package" />
    <label [for]="'package-'+item!.cssClassName" class="sell-package">
      <div *ngIf="item.titleBanner != undefined" class="uniko-exclusive">{{item?.titleBanner}}</div>
      <div class="flex flex-col gap-5 h-full">
        <div class="flex flex-row justify-between">
          <div class="package-details">
            <h3>{{item.title}}</h3>
            <span>{{item.unitPrice?.toFixed(2)}} €</span>
          </div>
          <div class="package-checkbox"></div>
        </div>
        <div class="flex flex-col gap-5 h-full">

          <div class="divider-line1"></div>
          <div class="text-gray-800 text-sm" [innerHTML]="item.description">
          </div>

        </div>

        <div *ngIf="item.learnMore" class="divider-line1"></div>
        <a *ngIf="item.learnMore" target="_blank" [href]="item.learnMoreLink"
          class="text-primary-700 font-semibold underline">Μάθε περισσότερα</a>
      </div>
    </label>
  </div>
